import Colors from "../../../Resources/Color";

// Color constants for pills
export const PILL_COLORS = {
  exercise: {
    background: "rgba(63, 123, 141, 0.12)",
    text: Colors.bubbleColor,
  },
  modifier: {
    background: "rgba(156, 156, 156, 0.12)",
    text: Colors.darkgrayColor,
  },
  library: {
    background: "rgba(156, 89, 182, 0.12)", // Purple tint
    text: "#8E44AD", // Purple
  },
  slot: {
    background: "rgba(218, 165, 32, 0.12)", // Gold tint
    backgroundHover: "rgba(218, 165, 32, 0.22)", // Gold tint hovered
    text: "#B8860B", // DarkGoldenrod
  },
  slotPill: {
    background: "rgba(255, 255, 255, 0.9)", // White for pill on gold background
    text: "#B8860B", // DarkGoldenrod
  },
};
